module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor01-ac06bc4091eae1ba3b5411e7480c2259.png";